module.exports = __webpack_public_path__ + "static/img/FMCG_capsule.b84d5340.gif";